module.exports = __webpack_public_path__ + "static/img/logo-complete.855deb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-complete.png
// module id = 791
// module chunks = 3